<template>
  <div class="page-toolbar mb-2">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PageToolbar',
}
</script>
